<template>
  <ElocusPage />
</template>
